import React from 'react';
import MapboxMap from './MapboxMap';
import type { Props } from './MapTypes';

import './Map.scss';

const Map = <T,>(props: Props<T>) => {
	return <MapboxMap {...props} />;
};

export default Map;
